import React, {Component} from 'react';
import Highlight from 'react-highlight.js';
import {Helmet} from "react-helmet";
class CodeBlock extends Component {

  constructor(props) {
    super(props);
    //Set default message
    this.state = {
    code: this.props.code,
    js: this.props.js,
    css: this.props.css,
    }
  }

  render(){ 

    const {lang, title, playground, bgColor} = this.props;

  return (
        <div class="code-block-container">
          <Helmet>
           <style>{`.cb-playground { background-color: ${bgColor};}`}</style>
        </Helmet>
            <div class="cb-item cb-code">
            <div class="cb-title-lang-con">
                    <div class="cb-title">
                        <p class="cb-pro-des">{ lang }</p>
                        <h2 class="cb-pro-tit">{ title }</h2>
                    </div>
                    <div class="cb-lang">
                        <button class="cb-lang-but">CSS</button>
                        <button class="cb-lang-but">JS</button>
                    </div>
                </div>
                <div className="cb-code-pure">
                <Highlight className={this.state.code}>
                {`
${this.state.js}
                  `}
                </Highlight>
                </div>
            </div>
            <div class="cb-item cb-playground">
              {playground}
            </div>
        </div>
  );
}
}

export default CodeBlock;
